
riot.tag2('treeview-check', '  <loader if="{opts.loader}"></loader>\n  <treenodes-check if="{!opts.loader}" nodes="{nodes}" handlers="{opts.handlers}" treeview="{this}" label-field="{labelField}" children-field="{childrenField}" dblclick="{opts.dblclick}">\n    <yield to="before">\n      <yield from="before"></yield>\n    </yield>\n    <yield to="after">\n      <yield from="after"></yield>\n    </yield>\n  </treenodes-check>\n', '', '', function(opts) {
'use strict';

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.nodes = [];
self.labelField = opts.labelField || 'label';
self.childrenField = opts.childrenField || 'children';
self.descendants = opts.descendants || undefined;

self.toggleChildren = function (node, value) {
    if (node[self.childrenField] && node[self.childrenField] instanceof Array) {
        node[self.childrenField].forEach(function (item) {
            item.__selected__ = value;
            self.toggleChildren(item, value);
        });
    }
};

self.toggleParent = function (item) {
    if (item.__parent__) {
        var parent = item.__parent__;
        if (parent instanceof Object && !(parent instanceof Array)) {
            var selected = parent[self.childrenField].map(function (i) {
                return i.__selected__;
            }).indexOf(false) <= -1;
            parent.__selected__ = selected;
            self.toggleParent(parent);
        }
    }
};

self.deselectAll = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            item.__selected__ = false;
            if (item[self.childrenField]) self.deselectAll(item[self.childrenField]);
        });
    }
};

self.getSelectedNodes = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    var result = [];
    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            if (item.__selected__) result.push(item);
            if (item[self.childrenField]) {
                var childResult = self.getSelectedNodes(item[self.childrenField]);
                result = [].concat(result, childResult);
            }
        });
        return result;
    }
    return [];
};

self.removeNodes = function () {
    var nodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.nodes;

    var result = [];
    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            if (item.__selected__) {
                nodes.splice(nodes.indexOf(item), 1);
                self.removeNodes(nodes);
                return;
            }
            if (item[self.childrenField]) {
                self.removeNodes(item[self.childrenField]);
            }
        });
    }
};

self.setNodes = function (nodesList) {
    var childsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (self.nodes.length == 0) {
        self.update();
    }
    if (childsList == false) {
        self.nodes.forEach(function (node) {
            if (nodesList.indexOf(node.id) > -1) {
                node.__selected__ = true;
                if (node.childs.length > 0) {
                    node.childs = self.setNodes(nodesList, node.childs);
                }
            }
            if (node.childs.length > 0) {
                node.childs = self.setNodes(nodesList, node.childs);
            }
        });
    } else {
        childsList.forEach(function (node) {
            if (nodesList.indexOf(node.id) > -1) {
                node.__selected__ = true;
            }
            if (node.childs.length > 0) {
                node.childs = self.setNodes(nodesList, node.childs);
            }
        });
        return childsList;
    }
};

function setParentLinks(nodes) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.nodes;

    if (nodes instanceof Array) {
        nodes.forEach(function (item) {
            Object.defineProperty(item, '__parent__', {
                writable: true,
                configurable: true,
                enumerable: false,
                value: parent
            });
            if ((typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) === 'object' && item[self.childrenField]) setParentLinks(item[self.childrenField], item);
        });
    }
}

self.on('update', function () {
    self.labelField = opts.labelField || 'label';
    self.childrenField = opts.childrenField || 'children';
    self.descendants = opts.descendants || undefined;

    if (self.nodes !== opts.nodes) {
        self.nodes = opts.nodes || [];
        setParentLinks(self.nodes);
    }
});
});
riot.tag2('treenodes-check', '  <ul each="{nodes}">\n    <li>\n      <div class="treenode" title="{title}" ondblclick="{dblclick}"><span class="icon {this[parent.childrenField].length ? expanded ? css.open  : css.closed : css.leaf}" onclick="{toggleExpand}"></span>\n        <yield from="before"></yield>\n        <input type="checkbox" onclick="{select}" __checked="{__selected__ ? true : false}">&nbsp;<span class="{this[parent.childrenField].length ? &quot;&quot; : &quot;leaf&quot;}">{this[parent.labelField]}</span>\n        <yield from="after"></yield>\n      </div>\n      <treenodes-check nodes="{this[parent.childrenField]}" dblclick="{dblclick}" handler="{parent.handler}" css="{parent.css}" if="{expanded}" handlers="{handlers}" treeview="{treeview}" label-field="{labelField}" children-field="{childrenField}">\n        <yield to="before">\n          <yield from="before"></yield>\n        </yield>\n        <yield to="after">\n          <yield from="after"></yield>\n        </yield>\n      </treenodes-check>\n    </li>\n  </ul>\n', 'treenodes-check ul,[riot-tag="treenodes-check"] ul,[data-is="treenodes-check"] ul{ list-style: none; padding-left: 2em; margin: 0.25em 0; } treenodes-check li,[riot-tag="treenodes-check"] li,[data-is="treenodes-check"] li{ cursor: pointer; margin-top:0.3em; } treenodes-check .icon,[riot-tag="treenodes-check"] .icon,[data-is="treenodes-check"] .icon{ width: 1.1em; } treenodes-check .treenode.selected,[riot-tag="treenodes-check"] .treenode.selected,[data-is="treenodes-check"] .treenode.selected{ background-color: #d9edf7; }', '', function(opts) {
'use strict';

var self = this;

self.treeview = opts.treeview;
self.labelField = opts.labelField || 'label';
self.childrenField = opts.childrenField || 'children';

self.nodes = opts.nodes || [];
//self.nodes.map(n => {
//    n.children = n.children || []
//    //n.__selected__ = false
//})

var doubleClick = opts.dblclick || function (e) {};

self.on('update', function () {
    self.title = opts.title;
    self.css = opts.css || { open: 'fa fa-fw fa-caret-down', closed: 'fa fa-fw fa-caret-right', leaf: 'fa fa-fw' };
    self.nodes = opts.nodes || [];
    self.handlers = opts.handlers || {};
    self.labelField = opts.labelField || 'label';
    self.childrenField = opts.childrenField || 'children';
});

self.dblclick = function (e) {
    doubleClick(e);
};

self.toggleExpand = function (e) {
    e.stopPropagation();
    e.item.expanded = !e.item.expanded;
};

self.select = function (e) {
    e.item.__selected__ = !e.item.__selected__;
    if (!e.ctrlKey) {
        self.treeview.toggleChildren(e.item, e.item.__selected__);
        if (self.treeview.descendants) {
            self.treeview.toggleParent(e.item);
            self.treeview.update();
        }
    } else {
        //self.treeview.deselectAll()
        if (self.treeview.descendants) {
            self.treeview.toggleChildren(e.item, e.item.__selected__);
        }
        self.treeview.update();
    }

    var count = self.treeview.getSelectedNodes().length;
    self.treeview.trigger('nodeselect', e.item, count);
};

self.stopPropagation = function (e) {
    e.stopPropagation();
};
});


// WEBPACK FOOTER //
// ./components/treeview-check.tag